const initialState = false

function isDirty(state = initialState, action) {
	switch (action.type) {
		case 'isDirty/set': {
			return action.payload
		}

		default: {
			return state
		}
	}
}

export default isDirty
